<template>
    <div class="data-section">
        <WideYesNo header="Участие в социальной работе" v-model="activity.isSocial">
            <ModelString
                label="Вид социальной работы"
                v-model="activity.socialActivity"
                :disabled="!activity.isSocial"
            />
        </WideYesNo>

        <WideYesNo header="Участие в волонтерских программах" v-model="activity.isVolunteer">
            <ModelString
                label="Вид волонтерской программы"
                v-model="activity.volunteerActivity"
                :disabled="!activity.isVolunteer"
            />
        </WideYesNo>

        <div></div>
    </div>
</template>

<script>
import WideYesNo from './WideYesNo';
import ModelString from '../../../UI/models/ModelString';

export default {
    name: 'WideSocialData',
    props: {
        activity: Object,
    },
    model: {
        prop: 'activity',
        event: 'change',
    },
    components: {
        WideYesNo,
        ModelString,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
